import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EventChoiceComponent } from "./event-choice.component";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatMenuModule } from "@angular/material/menu";
import { MatIconModule } from "@angular/material/icon";
import { DirectivesModule } from "app/shared/directives/directives.module";
import { MatToolbarModule } from "@angular/material/toolbar";
import { TranslocoModule } from "@ngneat/transloco";
import { NewFeatureStylingDirective } from "app/shared/directives/new-feature-styling.directive";

@NgModule({
  imports: [
    TranslocoModule,
    MatDialogModule,
    MatButtonModule,
    CommonModule,
    MatMenuModule,
    MatIconModule,
    DirectivesModule,
    MatToolbarModule,
    NewFeatureStylingDirective
  ],
  declarations: [EventChoiceComponent],
})
export class EventChoiceModule {}
